import SearchableSelect from "../../../../components/SearchableSelect";
import type {
  SearchOption,
  SearchOptionPaginationControl,
} from "../../../../types/searchSessions";

interface StreamCourtSelectProps {
  label: string;
  placeholder: string;
  searchPlaceholder: string;
  options: SearchOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  paginationControl?: SearchOptionPaginationControl;
  selectedLabel?: string;
}

const StreamCourtSelect = ({
  label,
  placeholder,
  searchPlaceholder,
  options,
  value,
  onChange,
  disabled = false,
  paginationControl,
  selectedLabel,
}: StreamCourtSelectProps) => {
  const selectedOption = options.find((option) => option.value === value);
  const optionsWithSelectedValue =
    value && !selectedOption
      ? [{ label: selectedLabel || value, value }, ...options]
      : options;

  return (
    <div>
      <label className="text-sm font-medium text-gray-600 mb-2 block">
        {label} *
      </label>
      <SearchableSelect
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        options={optionsWithSelectedValue}
        value={
          selectedOption ||
          (value ? { label: selectedLabel || value, value } : null)
        }
        onChange={(option: any) => onChange(option?.value || "")}
        disabled={disabled}
        onSearchChange={paginationControl?.onSearchChange}
        onLoadMore={paginationControl?.onLoadMore}
        hasMore={paginationControl?.hasMore}
        isLoadingMore={paginationControl?.isLoadingMore}
        isLoadingOptions={paginationControl?.isLoading}
      />
    </div>
  );
};

export default StreamCourtSelect;
